import { ConfirmationDialog } from "@/components";

import { JobStatus } from "@/types";

const jobStatusToConfirmationButtonVariant: Record<
  JobStatus,
  "default" | "destructive"
> = {
  [JobStatus.ACTIVE]: "default",
  [JobStatus.DRAFT]: "default",
  [JobStatus.CLOSED]: "destructive",
};

const jobStatusToConfirmationDescription: Record<JobStatus, string> = {
  [JobStatus.ACTIVE]:
    'This will move this job into the "Active" status allowing users on the talent platform to apply.',
  [JobStatus.DRAFT]: 'This will move this job into the "Draft" status.',
  [JobStatus.CLOSED]:
    'This will move all candidates not in [Offer, Placed, Employed] statuses to a Closed status.\n\nThis will also move this job into the "Closed" status.\n\nNEW: This will notify all mobile users in 2 days that the job has been closed',
};

export const JobStatusTransitionConfirmationDialog = ({
  jobStatus,
  isLoading,
  isError,
  onConfirm,
  onOpenChange,
  open,
  preventContentClickPropagation,
  preventOverlayClickCapturePropagation,
}: {
  jobStatus: JobStatus;
  isLoading?: boolean;
  isError?: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  preventContentClickPropagation?: boolean;
  preventOverlayClickCapturePropagation?: boolean;
}) => {
  return (
    <ConfirmationDialog
      confirmationButtonVariant={
        jobStatusToConfirmationButtonVariant[jobStatus]
      }
      description={jobStatusToConfirmationDescription[jobStatus]}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      open={open}
      preventContentClickPropagation={preventContentClickPropagation}
      preventOverlayClickCapturePropagation={
        preventOverlayClickCapturePropagation
      }
      title="Are you sure?"
      isLoading={isLoading}
      isError={isError}
    />
  );
};
